import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
  } from '@backstage/theme';
  

  export const DFBTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: {
        ...palettes.light,
        primary: {
          main: '#3db990',
        },
        secondary: {
          main: '#126449',
        },
        error: {
          main: '#8c4351',
        },
        warning: {
          main: '#8f5e15',
        },
        info: {
          main: '#34548a',
        },
        success: {
          main: '#485e30',
        },
        background: {
          default: '#ffffff',
          paper: '#ffffff',
        },
        errorBackground: '#8c4351',
        warningBackground: '#8f5e15',
        infoBackground: '#343b58',
        navigation: {
          background: '#76cdb1',
          indicator: '#6100ff',
          color: '#062017',
          selectedColor: '#6100ff',
          navItem: {
            hoverBackground: '#1c9870',
            }
        },
      },
    }),
    defaultPageTheme: 'home',
    /* below drives the header colors */
    pageTheme: {
      home: genPageTheme({ colors: ['#76cdb1', '#126449'], shape: shapes.round }),
      documentation: genPageTheme({
        colors: ['#76cdb1', '#126449'],
        shape: shapes.wave2,
      }),
      tool: genPageTheme({ colors: ['#76cdb1', '#126449'], shape: shapes.round }),
      service: genPageTheme({
        colors: ['#76cdb1', '#126449'],
        shape: shapes.wave,
      }),
      website: genPageTheme({
        colors: ['#76cdb1', '#126449'],
        shape: shapes.wave,
      }),
      library: genPageTheme({
        colors: ['#76cdb1', '#126449'],
        shape: shapes.wave,
      }),
      other: genPageTheme({ colors: ['#76cdb1', '#126449'], shape: shapes.wave }),
      app: genPageTheme({ colors: ['#76cdb1', '#126449'], shape: shapes.wave }),
      apis: genPageTheme({ colors: ['#76cdb1', '#126449'], shape: shapes.wave }),
    },
  });
  